import superagent from 'superagent'

const KML = {
  // Explicit-id mode on POST /kml/get. The endpoint binds this body to
  // ExportList { Markers, Measurements, Photos } and serialises exactly those
  // ids, so photos are supported today — no services change needed.
  //
  // The same endpoint also has a bounding-box mode taking ulLat/ulLon/lrLat/
  // lrLon plus exportMarkers/Tracks/Routes/Shapes/Photos flags. We deliberately
  // do not use it: it would move selection server-side, costing a round trip per
  // drag for the live count, and its Circle and Route branches are commented out.
  export: (markers, measurements, photos, token) => {
    const json = JSON.stringify({
      markers,
      measurements,
      photos
    })
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/get`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(json)
        .responseType('blob')
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  import: (fileData, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/upload`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(fileData)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  importCount: (fileData, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/kml/upload/?countOnly=true`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(fileData)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}

export default KML